import { useEffect, useState } from 'react';
import { type AdminSecurityAuditEventsSearchInput } from '../../types';
import api from '@/lib/api';
import CountTextWrapper from '@/routes/Audit/components/Events/CountTextWrapper';
import CountTextPlaceholder from '@/routes/Audit/components/Events/CountTextPlaceholder';

type AdminSecurityAuditEventCountProps = {
  searchInput: AdminSecurityAuditEventsSearchInput;
  shownSecurityAuditEventCount: number;
};

type SecurityAuditEventCounts = {
  totalCount: number;
  filteredCount: number;
};

const AdminSecurityAuditEventCount = ({
  searchInput,
  shownSecurityAuditEventCount,
}: AdminSecurityAuditEventCountProps) => {
  const [counts, setCounts] = useState<SecurityAuditEventCounts | null>(null);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setCounts(null);

    api
      .post<SecurityAuditEventCounts>(
        'admin-security-audit-events/count',
        searchInput,
      )
      .then(securityAuditEventCounts => {
        setCounts(securityAuditEventCounts);
      });
  }, [searchInput]);

  if (counts === null) {
    // This placeholder prevents page jumping when the count request completes
    return <CountTextPlaceholder />;
  }

  if (counts.totalCount === counts.filteredCount) {
    return (
      <CountTextWrapper>
        {counts.totalCount} total security events (
        {shownSecurityAuditEventCount} shown)
      </CountTextWrapper>
    );
  }

  return (
    <CountTextWrapper>
      Search matched {counts.filteredCount} of {counts.totalCount} security
      events ({shownSecurityAuditEventCount} shown)
    </CountTextWrapper>
  );
};

export default AdminSecurityAuditEventCount;
